/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Image
 */
export interface Image {
  /**
   *
   * @type {string}
   * @memberof Image
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof Image
   */
  urlMedium: string
  /**
   *
   * @type {string}
   * @memberof Image
   */
  urlSmall: string
  /**
   *
   * @type {string}
   * @memberof Image
   */
  urlThumbnail: string
}

/**
 * Check if a given object implements the Image interface.
 */
export function instanceOfImage(value: object): value is Image {
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('urlMedium' in value) || value['urlMedium'] === undefined) return false
  if (!('urlSmall' in value) || value['urlSmall'] === undefined) return false
  if (!('urlThumbnail' in value) || value['urlThumbnail'] === undefined)
    return false
  return true
}

export function ImageFromJSON(json: any): Image {
  return ImageFromJSONTyped(json, false)
}

export function ImageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Image {
  if (json == null) {
    return json
  }
  return {
    id: json['id'],
    urlMedium: json['url_medium'],
    urlSmall: json['url_small'],
    urlThumbnail: json['url_thumbnail'],
  }
}

export function ImageToJSON(json: any): Image {
  return ImageToJSONTyped(json, false)
}

export function ImageToJSONTyped(
  value?: Image | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    id: value['id'],
    url_medium: value['urlMedium'],
    url_small: value['urlSmall'],
    url_thumbnail: value['urlThumbnail'],
  }
}
